var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxVclara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M3 0h10c1.65574507 0 3 1.34425493 3 3v10c0 1.65574507-1.34425493 3-3 3H3c-1.65574507 0-3-1.34425493-3-3V3c0-1.65574507 1.34425493-3 3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxVclara);
export default __webpack_public_path__ + "static/media/checkbox_vclara.1012a22d40f0f876b06c2cbf31b2201f.svg";
export { ForwardRef as ReactComponent };